import { AgGridTable } from 'components/AgGrid/AgGridTable';
import { ConfirmationDialog } from 'components/ConfirmationDialog';
import { ModalDialog } from 'components/ModalDialog';
import type { AnyObject } from 'types/AnyObject';
import { IconAlert, Informer, Loader } from 'uikit';

import type { ColDef, ColGroupDef } from 'ag-grid-community';
import { useCallback, useState } from 'react';

import { useConstructionTypesListItems } from '../hooks/useConstructionTypesListItems';

import { getRowClass, getRowId } from './helpers';

import Styles from './AddWorkOrderOther.module.css';

interface IAddWorkOrderOther {
    constructionTypeId: number;
    btnConfirmLabel: string;
    onConfirm: () => void;
    tableColumns: (ColDef | ColGroupDef)[];
    tableData: AnyObject[];
    onCancel: () => void;
    isAddInProgress?: boolean;
    isDirty?: boolean;
    btnConfirmDisabled?: boolean;
    isTableLoading?: boolean;
}

export const AddWorkOrderOtherForm = ({
    constructionTypeId,
    onConfirm,
    isAddInProgress,
    onCancel,
    isDirty,
    btnConfirmDisabled,
    btnConfirmLabel,
    isTableLoading,
    tableColumns,
    tableData,
}: IAddWorkOrderOther) => {
    const { getConstructionTypeName } = useConstructionTypesListItems();
    const [isOpenWarningDialog, setIsOpenWarningDialog] = useState<boolean>(false);

    const handleCancel = useCallback(() => {
        if (isDirty) {
            setIsOpenWarningDialog(true);
        } else {
            onCancel();
        }
    }, [isDirty, onCancel]);

    const handleCloseExactly = useCallback(() => {
        onCancel();
    }, [onCancel]);

    const handleCancelWarningDialog = useCallback(() => {
        setIsOpenWarningDialog(false);
    }, []);

    return (
        <ModalDialog
            title={`Лимиты прочих затрат для вида строительства "${getConstructionTypeName(constructionTypeId)}"`}
            isOpen
            onConfirm={onConfirm}
            onClose={handleCancel}
            btnConfirmLabel={btnConfirmLabel}
            withTitleCloseButton
            style={{ maxWidth: 1240 }}
            isCommit={isAddInProgress}
            btnConfirmDisabled={btnConfirmDisabled}
            isOnClickOutsideDisable
        >
            <div style={{ margin: '20px' }}>
                <Informer
                    status="system"
                    label="Выбранные прочие затраты по умолчанию будут применены ко всем объектам данного вида строительства. Для того, чтобы исключить объекты, нажмите кнопку раскрытия и снимите выделение."
                    icon={IconAlert}
                />
            </div>
            <div className={Styles.otherTable}>
                {isTableLoading && <Loader />}
                {!isTableLoading && (
                    <AgGridTable
                        rowData={tableData}
                        columnDefs={tableColumns}
                        headerHeight={35}
                        rowClassRules={getRowClass}
                        getRowId={getRowId}
                    />
                )}
                {isOpenWarningDialog && (
                    <ConfirmationDialog
                        textHeader=""
                        textConfirmation="Вы уверены, что хотите отменить? Заполненные данные не будут сохранены"
                        cancelButtonText="Не отменять"
                        confirmButtonText="Отменить"
                        isOpened
                        onSubmit={handleCloseExactly}
                        onClose={handleCancelWarningDialog}
                    />
                )}
            </div>
        </ModalDialog>
    );
};

AddWorkOrderOtherForm.displayName = 'AddWorkOrderOtherForm';
